<template>
  <div class="row">
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>司機資料</h4>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">姓名:</h5>
            <h5 class="col-md-8">
              {{ driver === null ? null : driver.name }}
            </h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">性別:</h5>
            <h5 class="col-md-8">
              {{ driver === null ? null : driver.gender }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">司機呼號/編號:</h5>
            <h5 class="col-md-8">
              {{ driver === null ? null : driver.call_number }}
            </h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">司機電話:</h5>
            <h5 class="col-md-8">
              {{ driver === null ? null : driver.account }}
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">車輛牌照:</h5>
            <h5 class="col-md-8">
              {{ driver === null ? null : driver.licence }}
            </h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">車輛出牌年份:</h5>
            <h5 class="col-md-8">
              {{ driver === null ? null : driver.car_year }}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    driver: Object,
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/Driver.vue